var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('entete-page',{attrs:{"titre":_vm.$t('demande.titre')}}),_c('v-card',{staticClass:"mt-6"},[_c('demandes-tableau',{attrs:{"demandes":_vm.demandes,"colonnes-a-afficher":_vm.colonnesAffichees},on:{"naviguerCreerDemande":_vm.onNaviguerCreerDemande},scopedSlots:_vm._u([{key:"item.numeroDemande.contenu",fn:function(ref){
var item = ref.item;
return [_c('router-link',{staticClass:"demandes-tableau__lien-numero-demande ml-2",attrs:{"to":{
              name: _vm.routeConsulterDemande,
              params: { idDemande: item.id },
            }}},[_vm._v(" "+_vm._s(item.numeroDemande)+" ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }